export default __webpack_public_path__ + "static/media/Group 50@2x.21b3fc89.png";